import { markFeaturedStale } from './featured';

/**
 * Refresh the Updates strip when a discussion is started, over the same
 * websocket the discussion list already uses.
 *
 * ⚠️ RUNTIME LOOKUP, not an `ext:flarum/realtime/...` import. A cross-bundle
 * import is evaluated at module load and is `undefined` whenever the provider's
 * bundle happens to load second — which has emptied whole pages here before.
 * This runs at mount, by which point every bundle is in, and degrades to "the
 * strip simply does not live-update" if realtime is absent.
 *
 * Bound once for the life of the page: RealtimeState retains channel-ready
 * callbacks so they re-fire against a fresh channel after a reconnect, so
 * registering per mount would stack them up.
 */
const EVENT = 'Flarum\\Discussion\\Event\\Started';
let bound = false;
const listening = new WeakSet();
export default function watchForNewUpdates() {
  if (bound) return;
  const state = window.flarum?.reg?.get('flarum-realtime', 'forum/RealtimeState');
  if (!state?.onPublicChannelReady) return;
  bound = true;
  state.onPublicChannelReady(channel => {
    // Once per channel object: a reconnect hands us a fresh channel, and the
    // ready callback can fire again for the same one.
    if (!channel || listening.has(channel)) return;
    listening.add(channel);

    // 🚨 bind_GLOBAL, not bind(EVENT). flarum/realtime's own discussion list
    // tears down with `channel.unbind('…\\Started')` — no callback given — which
    // removes EVERY handler for that event, this one included. It happens on
    // any sort change or trip to a discussion, so the strip stopped updating
    // after the first navigation while the list below kept working (measured:
    // 2 handlers on load, 1 after a sort change). A global handler is not
    // touched by an event-specific unbind.
    //
    // Every new discussion refreshes the strip rather than only Updates ones.
    // Telling them apart means trusting the payload's tags, and a refetch is
    // one cheap request on an event that happens a few times a day.
    channel.bind_global(name => {
      if (name === EVENT) markFeaturedStale();
    });
  });
}